class HangMan {
  constructor(word, remainingGuesses) {
    this.word = word.toLowerCase().split('')
    this.remainingGuesses = remainingGuesses
    this.guessedLetters = []
    this.status = 'playing'
  }

  get gameStatus() {
    return this.status
  }

  get howManyRemainingGuesses() {
    return this.remainingGuesses
  }

  get whatAreTheGuessedLetters() {
    return this.guessedLetters
  }
  
  get puzzle() {
    let puzzle = ''

    this.word.forEach((letter) => {
      if (this.guessedLetters.includes(letter) || letter === ' ') {
        puzzle += letter
      } else {
        puzzle += '.'
      }
    })

    return puzzle
  }

  get solution() {
    return this.word.join('')
  }

  updateGame(newWord) {
    this.word = newWord.toLowerCase().split('')
  }
  
  isCorrectGuess(letter) {
    if (!this.word.includes(letter.toLowerCase())) {
      return false
    }
    
    return true
  }
  
  sumOfCorrectLetters(letter) {
    let sum = 0
    this.word.forEach(puzzleLetter => {
      if (letter.toLowerCase() === puzzleLetter) {
        sum++
      }
    })
    return sum
  }

  makeGuess(letter) {
    if (this.status === 'finished' || this.status === 'failed') {
      return
    }

    const isUnique = !this.guessedLetters.includes(letter.toLowerCase())
    const isBadGuess = !this.word.includes(letter.toLowerCase())

    if (isUnique) {
      this.guessedLetters.push(letter)
    }

    if (isUnique && isBadGuess) {
      this.remainingGuesses--
    }

    this.calculateStatus()
  }

  calculateStatus() {
    const isFinished = this.word.every((letter) => this.guessedLetters.includes(letter) || letter === ' ')

    if (this.remainingGuesses === 0) {
      this.status = 'failed'
    } else if (isFinished) {
      this.status = 'finished'
    }
  }

  get statusMessage() {
    if (this.status === 'failed') {
      return `You Lose!!!  The word was "${this.word.join('')}"`
    } else if (this.status === 'finished') {
      return 'You Win!!!'
    } else {
      return 'Keep Guessing!'
    }
  }
}

// Create alphabet array
const alphabet = []
for (let i = 0; i < 26; i++) {
  const letter = String.fromCharCode(65 + i)
  const id = letter.charCodeAt(0)
  const clickedLetter = false
  const correctGuess = null
  const letterObj = { letter, id, clickedLetter, correctGuess }
  alphabet.push(letterObj)
}

export { HangMan as default, alphabet}